module.exports = __webpack_public_path__ + "youtube.svg?f229dafb6e71610da73f94707cdef564";


//////////////////
// WEBPACK FOOTER
// ./index_files/images/youtube.svg
// module id = 32
// module chunks = 0